import React, { Component, Fragment } from 'react';
import '../global';
import { connect } from 'react-redux';
import { updateFormErrors } from '../actions';
import Loading from './loading-component';
import axios from 'axios';

class OrderSummary extends Component {

	constructor( props ) {
		super( props );
		this.state = {
			submittingOrder: false
		};
		this.handleCompleteOrder = this.handleCompleteOrder.bind( this );
        this.handleButtonClick = this.handleButtonClick.bind( this );
	}

	toggleSubmittingOrder() {
		this.setState( { submittingOrder: !this.state.submittingOrder } );
	}

    handleButtonClick() {
        // First, clear the general error
        if (this.props.form_errors && this.props.form_errors.general) {
            const updatedErrors = { ...this.props.form_errors };
            delete updatedErrors.general;
            this.props.updateFormErrors(updatedErrors);
        }

        // Then, call handleCompleteOrder
        this.handleCompleteOrder();
    }

	handleCompleteOrder() {
		const form = document.getElementById( 'bookstore-checkout' );
		if ( form ) {
			// Check for required fields that are empty
			const requiredFields = form.querySelectorAll( '[required]' );
			const emptyRequiredFields = Array.from( requiredFields )
			                                 .filter( field => !field.value.trim() );
			if ( emptyRequiredFields.length > 0 || (this.props.form_errors && Object.keys(this.props.form_errors).filter(key => key !== 'general').length > 0) ) {
				// Alert the user about empty required fields
				if ( emptyRequiredFields.length > 0 ) {
					const errorObject = emptyRequiredFields.reduce( ( acc, field ) => {
						acc[ field.name || field.id ] = 'This is a required field';
						return acc;
					}, {} );
					this.props.updateFormErrors( errorObject );
				}
				return;
			} else {
				// Get billing info from getCartInfo
				const { imis_billing_info } = getCartInfo();

				const billingFields = [
					{
						form: '_checkout_billing_address',
						imis: 'get_address_1'
					}, {
						form: '_checkout_billing_address_two',
						imis: 'get_address_2'
					}, {
						form: '_checkout_billing_country',
						imis: 'get_address_country'
					}, {
						form: '_checkout_billing_city',
						imis: 'get_address_city'
					}, {
						form: '_checkout_billing_state',
						imis: 'get_address_state'
					}, {
						form: '_checkout_billing_postal_code',
						imis: 'get_address_zip'
					}
				];

				// Update form fields with billing info
				billingFields.forEach( field => {
					const formField = form.elements[ field.form ];
					if ( formField && !formField.value && imis_billing_info[ field.imis ] ) {
						formField.value = imis_billing_info[ field.imis ];
					}
				} );

				this.toggleSubmittingOrder();

				// Create FormData after updating the form fields
				const formData = new FormData( form );
				let formValues = Object.fromEntries( formData.entries() );

				// Log the updated form values
				// Submit the form with updated values
				// form.submit();
                const url = `${ wpApiSettings.root }isda/v1/books/checkout/`;
                const headers =  {
                    'X-WP-Nonce': wpApiSettings.nonce
                }
				axios.post( url, formData, { headers }  )
				     .then( response => {
					     // Handle successful submission
                         if (response.data.success) {
                            window.location.href = '/books/thank-you'; // Replace with your actual success page URL
                            
                         } else {
                            this.toggleSubmittingOrder();
                            this.props.updateFormErrors( { general: response.data.message } );
                            window.scrollTo(0, 0); // Scroll to top of page
                         }
				     } )
				     .catch( error => {
					     // Handle submission error
					     console.error( 'Error submitting form', error );
					     this.toggleSubmittingOrder();
					     // Update UI to show error message
					     this.props.updateFormErrors( { general: 'An error occurred while processing your order. Please try again.' } );
					     window.scrollTo(0, 0); // Scroll to top of page
				     } );
			}
		}
	}

	render() {
		const are_there_products = Array.isArray( this.props.cart.products ) && this.props.cart.products.length > 0;
		return (<div className="row no-gutter col-md-4 col-lg-3">
				<div className="order-summary">
					<h3>Order Summary</h3>
					<hr/>
					<div>
						<div className="product-container">
							{ this.props.loading ? (
								<Loading amount={ 1 } height={ 40 }
								         width={ '90%' } margin={ '5%' }/>
							) : (are_there_products
							     ? (this.props.cart.products.map( ( item ) => (
											<div key={ item.iMIS_code }
											     className="order-summary-row">
												<div
													className="order-title-container">
													<h4>{ item.title }</h4>
													<p>{ item.type }</p></div>
												<span>{ item.quantity } x ${ item.price }</span>
											</div>
										) )
							     )
							     : (<div className="order-summary-row">No items
											in cart</div>
							     )
							  ) }
						</div>
						<hr/>
						<div className="order-summary-row">
							<span>Subtotal</span>
							{ this.props.loading ? (
								<Loading amount={ 1 } height={ 20 }
								         width={ 100 }/>
							) : (<span>${ this.props.cart.items_total }</span>
							  ) }
						</div>
						<div className="order-summary-row">
							<span>Shipping & Handling</span>
							{ this.props.loading ? (
								<Loading amount={ 1 } height={ 20 }
								         width={ 100 }/>
							) : (<span>${ this.props.cart.handling }</span>
							  ) }
						</div>
						<div className="order-summary-row">
							<span>Taxes</span>
							{ this.props.loading ? (
								<Loading amount={ 1 } height={ 20 }
								         width={ 100 }/>
							) : (<span>${ this.props.cart.taxes }</span>
							  ) }
						</div>
						<hr/>
						<div className="order-summary-row order-summary-total">
							<span>Total</span> { this.props.loading ? (
							<Loading amount={ 1 } height={ 20 } width={ 100 }/>
						) : (<span>${ this.props.cart.sum || 0 }</span>
							                     ) }
						</div>
					</div>
					<div class="cart-cta-buttons order-summary-row">
						{ this.props.currentStep === 1 ? (
							<button className="btn btn-default"
							        onClick={ () => {
								        this.props.onClickCheckout();
								        window.scrollTo( 0, 0 );
							        } }
							        disabled={ !are_there_products || this.props.loading }>
								Proceed to Payment
							</button>
						) : (<div>
							<button type="submit"
							        class="btn btn-default"
							        onClick={ this.handleButtonClick }
							        disabled={ this.state.submittingOrder }>{ this.state.submittingOrder
							                                                  ?
							                                                  <img
								                                                  src={ ISDA_Main.ajaxLoader }
								                                                  alt="Loading..."/>
							                                                  : 'Confirm Payment' }</button>
							<p className="terms-and-conditions-text">By clicking
								Confirm Payment, you agree to the <a
									href="/terms-and-conditions"
									target="_blank">Terms and Conditions</a>.
							</p>
						</div>
						  ) }

					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps( { cart, form_errors, loading } ) {
	return {
		cart, form_errors, loading

	};
}

export default connect( mapStateToProps, {
	updateFormErrors
} )( OrderSummary );